module.exports = __webpack_public_path__ + "img/doc_check_status.581f1768.png";